
const ImagePreviewObj = {}
import { ImagePreview } from "vant";

// Vue暴露了一个install方法，用于自定义插件
ImagePreviewObj.install = function (Vue) {
  Vue.prototype.$imagePreview = (list = [],index=0) => {
    ImagePreview({
      images: list,
      startPosition: index
    })
  };

}

export default ImagePreviewObj;
